// Device credentials at ~/.local/share/tktuner/credentials.json (chmod 600).
import { chmodSync, existsSync, mkdirSync, readFileSync, rmSync, writeFileSync } from "node:fs";
import { join } from "node:path";
import { dataDir } from "./paths";

export interface Credentials {
  apiUrl: string;
  deviceToken: string;
  deviceId: string;
  deviceName: string;
}

export function credentialsPath(): string {
  return join(dataDir(), "credentials.json");
}

export function readCredentials(): Credentials | null {
  try {
    const raw = readFileSync(credentialsPath(), "utf8");
    const parsed = JSON.parse(raw) as Partial<Credentials>;
    if (!parsed.apiUrl || !parsed.deviceToken || !parsed.deviceId) return null;
    return parsed as Credentials;
  } catch {
    return null;
  }
}

export function writeCredentials(creds: Credentials): void {
  mkdirSync(dataDir(), { recursive: true });
  const path = credentialsPath();
  writeFileSync(path, `${JSON.stringify(creds, null, 2)}\n`, { mode: 0o600 });
  chmodSync(path, 0o600); // mode above is ignored when the file already exists
}

export function deleteCredentials(): void {
  if (existsSync(credentialsPath())) rmSync(credentialsPath());
}
